export type Budget = {
  id: number;
  title: string;
  coa_id: string;
  base_data_set_id: string | null;
  owner_id: number;
  entity_id: number;
  created_at: string;
  updated_at: string;
  reference_data_set_ids: string[];
  finalized: boolean;
  phase: string;
  preferences: string;
  coa_stale: boolean;
  base_amount_type: string;
  base_lines_count: number;
  workforce_id: string | null;
  budget_type: string;
  budget_grouping_type: string;
  editing_restrictions: string;
  editing_locked: boolean;
  allocation_plan_id: string | null;
  pre_date_based: boolean;
  min_date: string;
  max_date: string;
  restricted_segments: { segment_index: number }[];
  proposal_segment_restrictions_applied: boolean;
  amount_scale: number;
  amount_scale_rule: string;
};

export const fetchBudget = async (budgetId: number): Promise<Budget | null> => {
  const response = await fetch(`/api/v1/budgets/${budgetId}`);
  if (!response.ok) {
    return Promise.reject(new Error(`Failed to fetch budget: ${response.statusText} (${response.status})`));
  }
  return (await response.json()) as Promise<Budget>;
};
